import request from '@/utils/request'

let HquessubApi = {

  /*问卷列表*/
  list(data) {
    return request._post('/shop/plus.hquessub.Index/index', data);
},

/*删除问卷*/
del(data) {
    return request._post('/shop/plus.hquessub.Index/del', data);
},
finish(data) {
  return request._post('/shop/plus.hquessub.Index/finish', data);
},

}
export default HquessubApi;



// WEBPACK FOOTER //
// ./src/api/hquessub.js